<template>
	<v-layout row wrap class="finance-table-row finance-table-header">
		<v-flex d-flex xs1>
			<v-card color="primary">
				<v-card-text class="px-2">
					<strong>Nr poz.</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card color="primary">
				<v-card-text style="padding-right: 8px">
					<strong>Rodzaj kosztu</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card color="primary">
				<v-card-text style="padding-left: 2px; padding-right: 2px; text-align: center">
					<strong>Liczba jednostek</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card color="primary">
				<v-card-text style="padding-left: 0; padding-right: 0; text-align: center">
					<strong class="no-print">Koszt jednostkowy</strong>
					<strong class="d-none print-only">Koszt jednostk.</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card color="primary">
				<v-card-text style="padding-left: 2px; padding-right: 2px; text-align: center">
					<strong>Rodzaj miary</strong>
				</v-card-text>
			</v-card>
		</v-flex>

		<v-flex d-flex xs2>
			<v-card color="primary">
				<v-card-text style="padding-left: 2px; padding-right: 2px; text-align: center">
					<strong>Koszt całkowity <span>(w&nbsp;zł)</span></strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs2>
			<v-card color="primary">
				<v-card-text style="padding-left: 2px; padding-right: 2px; text-align: center">
					<strong>Z dotacji <span>(w&nbsp;zł)</span></strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card color="primary">
				<v-card-text style="padding-left: 0; padding-right: 0; text-align: center">
					<strong class="no-print">Z innych środków finansowych <span>(w&nbsp;zł)</span></strong>
					<strong class="d-none print-only">Z innych środków finans. <span>(w&nbsp;zł)</span></strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card color="primary">
				<v-card-text style="padding-left: 2px; padding-right: 2px; text-align: center">
					<strong>Wkład osobowy <span>(w&nbsp;zł)</span></strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card color="primary">
				<v-card-text style="padding-left: 2px; padding-right: 2px; text-align: center">
					<strong>Wkład rzeczowy <span>(w&nbsp;zł)</span></strong>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>
<script>
	export default {
		name: 'costs-calculated-headers'
	};
</script>

<style scoped>
	.theme--dark .grey.lighten-1 {
		background-color: #0052A5 !important;
	}

	.application.mediumFont strong {
		font-size: 1em;
	}

	.application.largeFont strong {
		font-size: 1em;
	}
	
	.finance-table strong {
		font-size: 13px;
	}
	.finance-table .v-card__text {
		padding-top: 7px;
		padding-bottom: 7px;
	}

	.v-card__text {
		color: #fff !important;
	}

	.finance-table .v-card__text strong {
		font-size: 10px;
	}

	.finance-table-header strong span {
		font-size: 10px;
		display: block;
	}
</style>